(ns minorodata.connections.sources.e-conomic
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id           "e-conomic"
   :enabled      true
   :name         "E-conomic"
   :description  "Addresses all your bookkeeping needs in one intuitive accounting program"
   :image-source "e-conomic.png"
   :tags         ["data-import"]

   :preview-formatter (fn [] "")

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [name description private-token agreement-grant-token]} data]
        {:source-type "e-conomic"
         :name        name
         :description description

         :source
         {:credentials         {:type                   "token"
                                :private-token          private-token
                                :agreement-grant-token  agreement-grant-token}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge
         (select-keys credentials [:private-token :agreement-grant-token])
         {:name              name
          :description       description})))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (constantly nil)

    :id :e-conomic-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Private Token"
              :required   true
              :name       :private-token
              :type       :password
              :value      ""}
             {:block-type :input
              :label      "Agreement Grant Token"
              :required   true
              :name       :agreement-grant-token
              :type       :password
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action destination-table report
                 use-interval start-date end-date]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:report            report
                    :destination-table destination-table
                    :action            action
                    :use-interval      use-interval
                    :start-date        start-date
                    :end-date          end-date}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:report :action :destination-table
                               :use-interval :start-date :end-date])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status}))))

    :validate (constantly nil)

    :id :e-conomic-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    [{:name "Customers"          :value "customers"}
                           {:name "Booked Invoices"    :value "invoices-booked"}
                           {:name "Draft Invoices"     :value "invoices-drafts"}
                           {:name "Accounting Entries" :value "accounting-entries"}
                           {:name "Journal Entries"    :value "journal-entries"}
                           {:name "Journal Vouchers"   :value "journal-vouchers"}]
              :required   true
              :value      "customers"}

             {:block-type :checkbox
              :label      "Use interval"
              :name       :use-interval
              :type       :checkbox
              :value      false
              :conditions [[:eq [:report :value] "accounting-entries"]
                           [:eq [:report :value] "journal-entries"]]}

             {:block-type :subtitle
              :content    ""}

             {:block-type :date-picker
              :label      "From"
              :name       :start-date
              :required   false
              :conditions [[:eq [:use-interval :value] true]]}

             {:block-type :date-picker
              :label      "To"
              :name       :end-date
              :required   false
              :conditions [[:eq [:use-interval :value] true]]}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
